import { render, staticRenderFns } from "./HmiPulsador.vue?vue&type=template&id=04c60b24&lang=true"
import script from "./HmiPulsador.vue?vue&type=script&lang=js"
export * from "./HmiPulsador.vue?vue&type=script&lang=js"
import style0 from "./HmiPulsador.vue?vue&type=style&index=0&id=04c60b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports